import React, { useEffect, useState } from "react";
import styles from "../VideoChooser.scss";
import { capitalizeFirstLetter } from "../PatientPlaylistTools";
import {
  patientRequest,
  getCategoriesRequest1,
  getCategoryVideosRequest1,
  getCategoriesDone1,
  getLngLatMapRequest,
  getQrCodeVisiteRequest,
} from "../actions";
import { connect } from "react-redux";
import MaterialIcon from "material-icons-react";
import Loading from "../../utils/loading/Loading";
import { Modal } from "./Modal";
import { DoctorLocation } from "./DoctorLocation/DoctorLocation";
import { getSubdomainUrl } from "../PatientPlaylistTools";
import Notifications from "../Notifications";

const InfoDoctor = ({ patientRequest, getLngLatMapRequest, ...props }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleClose = () => {
    setIsModalOpen(false);
  };

  const [state, setState] = useState({
    verifSiteWebRdv: false,
    showToastMessageRdv: true,
    getMap: false,
  });

  const {
    "video-patient": { authData },
    "google-map": {
      mapLngLatRequesting,
      mapLngLatError,
      mapLngLatSuccess,
      lngLat,
    },
  } = props;

  useEffect(() => {
    if (!authData) {
      const sd = getSubdomainUrl();
      patientRequest({ subdomain: sd });
    }
  }, [authData]);

  useEffect(() => {
    if (authData) {
      getMap(authData);
    }
  }, [authData]);

  useEffect(() => {
    if (state.showToastMessageRdv || state.verifSiteWebRdv) {
      setTimeout(() => {
        setState({
          showToastMessageRdv: false,
          verifSiteWebRdv: false,
        });
      }, 4000);
    }
  }, [state]);

  const navigateBack = () => {
    props.history.goBack();
  };

  // Passage de authData pour la map
  const getMap = (authData) => {
    if (typeof props["google-map"].lngLat === "undefined") {
      if (authData) {
        getLngLatMapRequest(authData);
      }
    }
  };

  // TODO This feature needs to be re-tested since migrated from PatientView
  const VerifSiteWeb = (authData) => {
    if (authData) {
      if (authData.otherurl) {
        setState({
          verifSiteWeb: true,
          showToastMessageWeb: false,
        });
        window.open(authData.otherurl);
      } else {
        setState({
          verifSiteWeb: false,
          showToastMessageWeb: true,
        });
      }
    }
  };

  // TODO This feature needs to be re-tested since migrated from PatientView
  const verifSiteWebRdv = (authData) => {
    if (authData) {
      if (authData.appointmenturl) {
        setState({
          verifSiteWebRdv: true,
          showToastMessageRdv: false,
        });
        window.open(authData.appointmenturl);
      } else {
        setState({
          verifSiteWebRdv: false,
          showToastMessageRdv: true,
        });
      }
    }
  };

  if (lngLat && lngLat.latitude && lngLat.longitude) {
    var LAT = lngLat.latitude;
    var LNG = lngLat.longitude;
  }

  return (
    <React.Fragment>
      {state.showToastMessageRdv && <Notifications />}
      {state.showToastMessageWeb && <Notifications />}

      <div className={styles.videoView}>
        <a className={styles.active} onClick={() => navigateBack()}>
          <MaterialIcon color="#ffffff" icon="keyboard_arrow_left" size={40} />
        </a>
      </div>

      <div
        className={styles.containerInfo}
        style={{ position: "relative", top: "40px" }}
      >
        {/* BEGIN Logo doctor */}
        <div className={styles.wrapper}>
          <img className={styles.imgProfile} src="assets/img/img-profile.png" />
        </div>
        {/* END Logo doctor */}
        {/* BEGIN display First Name, Last Name and Specialty */}
        <div className={styles.textMed}>
          <span className={styles.specName}>
            {" "}
            {authData ? authData.firstName : ""}{" "}
            {authData ? authData.lastName : ""}
          </span>
          <br></br>
          <span className={styles.speciality}>
            {authData ? authData.speciality : ""}
          </span>
        </div>
        {/* BEGIN display First Name, Last Name and Specialty */}
        {/* BEGIN Row the button (Localisation & Phone) */}
        <div
          styles={{
            width: "100%",
          }}
        >
          {authData && authData.postaladdress ? (
            <a
              className={styles.locBtn}
              style={{
                backgroundColor: "#1992ec",
                padding: "10px 0px",
                color: "#fff",
                fontSize: "19px",
                width: "48.5%",
                display: "inline-block",
                textAlign: "center",
                cursor: "pointer",
              }}
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              Localiser le cabinet
            </a>
          ) : (
            <a
              className={styles.locBtn}
              style={{
                backgroundColor: "#1992ec",
                padding: "10px 0px",
                color: "#fff",
                fontSize: "19px",
                width: "48.5%",
                display: "inline-block",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              Adresse non saisie
            </a>
          )}
          {authData && authData.phonenumber ? (
            <a
              href={"tel:" + authData.phonenumber}
              className={styles.numBtn}
              style={{
                backgroundColor: "#1992ec",
                padding: "10px 50px",
                marginLeft: "5px",
                fontSize: "19px",
                width: "49%",
                display: "inline-block",
                color: "#fff",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              {authData && authData.phonenumber ? authData.phonenumber : ""}
            </a>
          ) : (
            <a
              href={"tel:" + (authData ? authData.phonenumber : "")}
              className={styles.numBtn}
              style={{
                backgroundColor: "#1992ec",
                padding: "10px 50px",
                marginLeft: "5px",
                fontSize: "19px",
                width: "49%",
                display: "inline-block",
                color: "#fff",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              n° non saisi
            </a>
          )}
          <a
            onClick={() => {
              VerifSiteWeb(authData);
            }}
            className={styles.webBtn}
            style={{
              backgroundColor: "#1992ec",
              padding: "10px 50px",
              fontSize: "19px",
              width: "48.5%",
              color: "#fff",
              marginTop: "5px",
              textAlign: "center",
              cursor: "pointer",
              display: "inline-block",
            }}
          >
            Site Web
          </a>
          <a
            onClick={() => {
              verifSiteWebRdv(authData);
            }}
            className={styles.rdvBtn}
            style={{
              backgroundColor: "#1992ec",
              padding: "10px 50px",
              marginLeft: "5px",
              width: "49%",
              fontSize: "19px",
              color: "#fff",
              textAlign: "center",
              cursor: "pointer",
              display: "inline-block",
            }}
          >
            Site rendez-vous
          </a>
        </div>
        {/* END Row the button (WebSite & Contact)  */}

        {/* END Main container for info section and videos section */}
      </div>

      <Modal
        open={isModalOpen}
        onClose={handleClose}
        aria-labelledby="google-maps-modal"
        aria-describedby="google-maps-modal"
      >
        <React.Fragment>
          {mapLngLatSuccess && !mapLngLatError && !mapLngLatRequesting && (
            <DoctorLocation
              firstName={authData.firstName}
              lastName={authData.lastName}
              lat={LAT}
              lng={LNG}
            />
          )}
          {mapLngLatError && !mapLngLatRequesting && !mapLngLatSuccess && (
            <div>
              <p>ERROR MAP</p>
            </div>
          )}
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  "video-patient": state["video-patient"],
  "google-map": state["google-map"],
  // numberVisite: state.getQrCodeVisiteRequest,
});

export default connect(mapStateToProps, {
  getCategoriesRequest1,
  getCategoryVideosRequest1,
  getLngLatMapRequest,
  getCategoriesDone1,
  patientRequest,
  getQrCodeVisiteRequest,
})(InfoDoctor);



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/InfoDoctor/InfoDoctor.jsx